<script lang="ts" setup>
import { RouterView } from 'vue-router'
import SettingsOrganizationTabMenu from '@/components/navigation/SettingsOrganizationTabMenu.vue'
</script>

<template>
    <div class="organization-settings-tabs">
        <SettingsOrganizationTabMenu />
    </div>
    <RouterView />
</template>

<style lang="scss" scoped>
.organization-settings-tabs {
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
}
</style>
